import { SpinningLoader } from "risa-oasis-ui_v2";

interface ProcessesOrderInfoCardsProps {
  processedOrdersToday?: {
    completion_percentage: number;
    orders_processed: number;
    orders_remaining: number;
    time_taken: string;
    loading: boolean;
  };
  showLoading?: boolean;
}

interface CardData {
  label: string;
  value: string | number;
  bgColor: string;
  textColor: string;
  borderColor: string;
}

const ProcessesOrderInfoCards = (props: ProcessesOrderInfoCardsProps) => {
  const { processedOrdersToday } = props;

  const cardData: CardData[] = [
    {
      label: "Completion Percentage",
      value: `${processedOrdersToday?.completion_percentage}%`,
      bgColor: "bg-[#E6F3F0]",
      textColor: "text-[#005D49]",
      borderColor: "border-[#005D49]",
    },
    {
      label: "Orders Processed",
      value: processedOrdersToday?.orders_processed ?? 0,
      bgColor: "bg-secondaryYellow-11",
      textColor: "text-secondaryYellow-2",
      borderColor: "border-secondaryYellow-2",
    },
    {
      label: "Orders Remaining",
      value: processedOrdersToday?.orders_remaining ?? 0,
      bgColor: "bg-tertiaryRed-11",
      textColor: "text-tertiaryRed-3",
      borderColor: "border-tertiaryRed-3",
    },
    {
      label: "Time Taken",
      value: processedOrdersToday?.time_taken ?? "",
      bgColor: "bg-primaryGray-15",
      textColor: "text-primaryGray-3",
      borderColor: "border-primaryGray-3",
    },
  ];

  return (
    <div className="flex h-full w-full items-center justify-center">
      {props.showLoading ? (
        <div className="flex h-full w-full items-center justify-center">
          <SpinningLoader />
        </div>
      ) : (
        <div className="processed-order-info-cards grid h-full w-10/12 grid-cols-2 gap-4 pb-8 pt-4">
          {cardData.map((card, index) => (
            <div
              key={index}
              className={`${card.bgColor} ${card.textColor} ${card.borderColor} flex flex-col items-center justify-center rounded-lg border-1 p-8`}
            >
              <div className="mb-2 text-h6 font-bold leading-h6">
                {card.value}
              </div>
              <div className="text-center text-small font-regular opacity-90">
                {card.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProcessesOrderInfoCards;
